/**
 * お届け先住所の更新を担う
 */
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFetch } from '../common/useFetch';
import { useEmitMessage } from '../common/useEmitMessage';
import { SubscriptionState } from '../App/useSubscription';
import { ShippingAddress } from '../ShippingAddress/useShippingAddress';

export const useUpdateShippingAddress = (
  subscription: SubscriptionState,
  getSubscriptions: () => void,
  token: string,
): UseUpdateShippingAddress => {

  const history = useHistory();
  const emitMessage = useEmitMessage();

  // 通信完了時、URLの遷移とサブスクデータの更新を行う
  const success = useCallback(() => {
    if (!subscription || !getSubscriptions) return;
    history.push('/shippingAddress');
    emitMessage('app-modify-address');
    getSubscriptions();
  }, [subscription, getSubscriptions]);

  const failed = () => emitMessage('app-error', 'keep');

  const [updateShippingAddressState, callUpdateShippingAddress] = 
    useFetch('updateDeliveryAddress', token, success, failed);

  // 通信開始時メッセージ出力
  useEffect(() => {
    if (updateShippingAddressState.loading === true)
      emitMessage('app-updating-address', 'keep');
  }, [updateShippingAddressState])

  const updateShippingAddress = useCallback((
    inputAddress: ShippingAddress
  ) => {
    if (!subscription?.subscriptionContractId || !inputAddress) return;

    callUpdateShippingAddress({
      subscriptionId: subscription.subscriptionContractId,
      deliveryAddress1: inputAddress.address1,
      deliveryAddress2: inputAddress.address2,
      deliveryCity: inputAddress.city,
      deliveryCompany: inputAddress.company,
      deliveryCountryCode: inputAddress.countryCode,
      deliveryFirstName: inputAddress.firstName,
      deliveryLastName: inputAddress.lastName,
      deliveryPhone: inputAddress.phone,
      deliveryProvinceCode: inputAddress.provinceCode,
      deliveryZip: inputAddress.zip,
    })
  }, [subscription]);

  return [ updateShippingAddressState.loading, updateShippingAddress ];
}

// types

export type UseUpdateShippingAddress = [
  boolean,
  (inputAddress: ShippingAddress) => void
]

export type UpdateShippingAddressParameter = {
  subscriptionId: string;
  deliveryAddress1: string;
  deliveryAddress2: string;
  deliveryCity: string;
  deliveryCompany: string;
  deliveryCountryCode: string;
  deliveryFirstName: string;
  deliveryLastName: string;
  deliveryPhone: string;
  deliveryProvinceCode: string;
  deliveryZip: string;
}